export const countryCodes = {
    "+54": {
        "name": "+54 Argentina",
        "image": "https://www.countryflags.io/AR/flat/64.png"
    }
};